/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import { cellRenderer,cellRendererFourDec } from '../../../../SharedModules/utilities/utilities';

const textMatcherAmount = ({ filterOption, value: val, filterText }) => {
  const value = Math.abs(val).toString();
  const valueWithDollar = `$ ${value}`;
  if (filterText == null) {
    return false;
  }
  switch (filterOption) {
    case 'contains':
      return (
        value.indexOf(filterText) >= 0 ||
        valueWithDollar.indexOf(filterText) >= 0
      );
    case 'notContains':
      return (
        value.indexOf(filterText) < 0 || valueWithDollar.indexOf(filterText) < 0
      );
    case 'equals':
      return value === filterText || valueWithDollar.indexOf(filterText) === 0;
    case 'notEqual':
      return value != filterText.replace('$', '');
    case 'startsWith':
      return (
        value.indexOf(filterText) === 0 ||
        valueWithDollar.indexOf(filterText) === 0
      );
    case 'endsWith':
      const index =
        value.lastIndexOf(filterText) || valueWithDollar.indexOf(filterText);
      return index >= 0 && index === value.length - filterText.length;
    default:
      return false;
  }
};
export const CurrentToPrevious = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_400,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    columnSpan: 3,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Quarter',
    field: 'currQtr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Billed Amount',
    field: 'billedAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_180,
    printPrefixValue: '$',
    cellRenderer: cellRenderer,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherAmount,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Billed Quantity',
    field: 'billedQty',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_180,
    comparator: (a, b) => parseFloat(a) - parseFloat(b),
    cellRenderer: cellRendererFourDec,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    excelAlignment: 'right',
    isTextColorRed: true,
    exportZeroesFour:true,
  },
  {
    headerName: 'Quarter ',
    field: 'prevQtr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Billed Amount ',
    field: 'prevBilledAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_180,
    printPrefixValue: '$',
    cellRenderer: cellRenderer,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherAmount,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Billed Quantity ',
    field: 'prevBilledQty',
    editable: false,
    sortable: true,
    suppressMenu: false,
    exportZeroesFour:true,
    resizable: true,
    minWidth: Styles.Width_180,
    comparator: (a, b) => parseFloat(a) - parseFloat(b),
    cellRenderer: cellRendererFourDec,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    excelAlignment: 'right',
  },
];
